import { useCallback, useState } from "react";
import { useIntl } from "react-intl";
import { Divider, Header, Icon, Popup, Segment } from "semantic-ui-react";
import RetargetingSegmentsService from "../../../services/retargeting-segments";
import { walmartMXTranslations } from "../../../translations/walmartMXTranslations";
import AppNotification from "../../common/notification-banner/app-notification";
import RetargetingSegmentsForm from "../form";

const initialData = {
  advertiser_id: null,
  attribution_level: "brand",
  brand_names: [],
  event_type: null,
  name: "",
  seller_id: null,
  seller_name: null,
  sku_ids: "",
};

const backUrl = "/retargeting-segments";

const RetargetingSegmentCreatePage = ({ history }) => {
  const intl = useIntl();
  const service = new RetargetingSegmentsService();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [serverError, setServerError] = useState(null);

  const handleCreateRetargetingSegment = async (values) => {
    setIsSubmitting(true);
    try {
      const { attribution_level, sku_ids, ...rest } = values;
      const payload = {
        ...rest,
        sku_ids: attribution_level === "sku" && sku_ids ? sku_ids.split(",").map((sku) => sku.trim()) : [],
      };
      await service.createRetargetingSegment(payload);
      history.push(backUrl, { action: "created" });
    } catch (e) {
      setServerError(e?.error?.message || e?.message || "An unexpected error occurred.");
    } finally {
      setIsSubmitting(false);
    }
  };

  /**
   * navigate user back
   */
  const navigateToGrid = useCallback(() => {
    history.push(backUrl);
  }, [history]);

  return (
    <Segment basic>
      <AppNotification
        isError
        onDismiss={() => setServerError(null)}
      >
        {serverError}
      </AppNotification>
      <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
        <Header
          as="h2"
          style={{ marginBottom: 0 }}
        >
          {intl.formatMessage({
            id: "HEADING_CREATE_BRAND_SKU_SEGMENT",
            defaultMessage: "Create Brand and SKU Segment",
          })}
        </Header>
        <Popup
          inverted
          content={<div>{walmartMXTranslations.tooltipBrandSkuTitleSpanish}</div>}
          size="mini"
          trigger={
            <Icon
              name="help circle"
              style={{ position: "relative", lineHeight: "normal" }}
              className="cursor-help"
            />
          }
        />
      </div>

      <Divider />
      <div style={{ display: "flex", gap: "20px", alignItems: "flex-start" }}>
        <div style={{ flex: 1 }}>
          <RetargetingSegmentsForm
            formType="create"
            isSubmitting={isSubmitting}
            initialData={initialData}
            onCancel={navigateToGrid}
            onSubmit={handleCreateRetargetingSegment}
            submitText={intl.formatMessage({
              id: "BUTTON_CREATE_BRAND_SKU_SEGMENT",
              defaultMessage: "Create Brand and SKU Segment",
            })}
          />
        </div>
      </div>
    </Segment>
  );
};

export default RetargetingSegmentCreatePage;
